module.exports = __webpack_public_path__ + "static/media/03.Akademy Prog.aa5332d6.JPG";